"use client";

import ResetAllJobsButton from "./ResetAllJobsButton";

type JobsEmptyStateProps = {
  title: string;
  description: string;
  onReset: () => void;
};

export default function JobsEmptyState({
  title,
  description,
  onReset,
}: JobsEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <p className="text-text-primary text-xl font-semibold">{title}</p>
      <p className="text-md text-text-secondary/60 mt-2 mb-6">{description}</p>
      <ResetAllJobsButton onClick={onReset} />
    </div>
  );
}
